// Import polyfills first
import '@babel/polyfill'
import 'whatwg-fetch'
import '@stimulus/polyfills'

// Import Bugsnag bug tracking
import './bugsnag'

import Turbolinks from 'turbolinks'
import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'
import './checkbrowser'
import './fontawesome'
import './smoothscroll'

Turbolinks.start()

// Import SCSS files
import './css/main.scss'

const application = Application.start()
const context = require.context('./controllers', true, /\.js$/)
application.load(definitionsFromContext(context))
